import imgCharla1 from "../../img/img_asesorias/Charla1.jpg";
import imgCharla2 from "../../img/img_asesorias/Chalra2.jpeg";
import imgMantencion from "../../img/img_asesorias/mantencion_ia.png";
import { useState, useEffect } from "react";
import LandingLayout from "./LandingLayout";
import { MdTimeline } from "react-icons/md";

const LandingServicios = () => {
    const [currentImage, setCurrentImage] = useState(0);
    const images = [imgCharla1, imgCharla2];

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentImage((prev) => (prev + 1) % images.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    return (
        <LandingLayout>
            <div className="py-16 lg:py-24 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="text-center mb-16">
                        <h2 className="text-amber-600 font-bold tracking-wide uppercase mb-2">Soluciones Expertas</h2>
                        <h1 className="text-4xl font-extrabold text-gray-900 sm:text-5xl">Nuestros Servicios</h1>
                        <p className="mt-4 text-xl text-gray-500 max-w-2xl mx-auto">Cobertura integral para la industria de combustibles.</p>
                    </div>

                    <div className="space-y-24">
                        {/* ASESORÍA */}
                        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                            <div className="relative h-[400px] w-full bg-slate-900 rounded-3xl overflow-hidden shadow-2xl flex items-center justify-center group transform transition-all duration-500 hover:scale-[1.02]">
                                {images.map((img, index) => (
                                    <div
                                        key={index}
                                        className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${currentImage === index ? "opacity-100" : "opacity-0"
                                            }`}
                                    >
                                        <img
                                            src={img}
                                            alt={`Asesoría Técnica ${index + 1}`}
                                            className="w-full h-full object-cover opacity-90 group-hover:scale-110 transition-transform duration-[2000ms]"
                                        />
                                        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
                                    </div>
                                ))}

                                {/* Indicators */}
                                <div className="absolute bottom-6 flex gap-2 z-20">
                                    {images.map((_, idx) => (
                                        <button
                                            key={idx}
                                            onClick={() => setCurrentImage(idx)}
                                            className={`w-3 h-3 rounded-full transition-all duration-300 ${currentImage === idx
                                                ? "bg-amber-500 w-8"
                                                : "bg-white/50 hover:bg-white"
                                                }`}
                                        />
                                    ))}
                                </div>
                            </div>
                            <div className="mt-8 lg:mt-0">
                                <h3 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3">
                                    <span className="w-2 h-8 bg-amber-500 rounded-full"></span>
                                    Asesoría Técnica
                                </h3>
                                <div className="text-lg text-gray-600 mb-6 leading-relaxed space-y-4 text-justify">
                                    <p>
                                        Las más grandes empresas en el área petrolera cuentan con personal capacitado para desarrollar grandes trabajos, los cuales permiten a diario a estas permanecer en competencia. Sin embargo, es importante precisar que para nuestros clientes no es necesario contar con un experto en mesas de carga permanentemente en Planta, por lo que se hace necesario buscar apoyo externo de empresas con la experiencia necesaria dedicadas al gran pero limitado rubro del combustible.
                                    </p>
                                    <p className="font-medium text-gray-800 border-l-4 border-amber-500 pl-4 italic">
                                        Es por esto que nace una de nuestras principales intenciones «Asesorar» a nuestros clientes con el fin de hacerle ver que sus inversiones estén de acuerdo a sus necesidades.
                                    </p>
                                    <p>
                                        Para tranquilidad de nuestros clientes <strong>Asesorías Técnicas y Mantención Ltda.</strong> cuenta con personal calificado por <strong>FMC Technologies</strong>, empresa norteamericana con presencia en diversos países, proveedora de sistemas y soluciones para la industria Petrolera.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* MANTENCIÓN */}
                        <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center">
                            {/* Text Section (Moved First) */}
                            <div>
                                <h3 className="text-3xl font-bold text-gray-900 mb-6 flex items-center gap-3 justify-start">
                                    <span className="w-2 h-8 bg-amber-500 rounded-full"></span>
                                    Mantención Especializada
                                </h3>
                                <div className="text-lg text-gray-600 mb-6 leading-relaxed space-y-4 text-justify">
                                    <p>
                                        Garantizamos la operatividad continua de sus instalaciones mediante programas de mantenimiento de alto nivel. Nuestro servicio va más allá de la reparación; nos enfocamos en la <strong>confiabilidad y precisión</strong> de cada componente crítico de su planta.
                                    </p>
                                    <p>
                                        Cada ciertos años, <strong>FMC Technologies</strong> se encarga de capacitar al personal de las empresas dedicadas a la instalación, puesta en marcha y mantención de equipos petroleros.
                                    </p>
                                    <div className="bg-amber-50 p-4 rounded-xl border border-amber-100 shadow-sm">
                                        <p className="text-amber-800 font-semibold">
                                            Acreditación de Excelencia:
                                        </p>
                                        <p className="text-gray-700 italic mt-1">
                                            Don <strong>Sandor Valdés Godoy</strong>, Gerente General y dueño de Asesorías Técnicas y Mantención Ltda., se encuentra debidamente acreditado con dichas capacitaciones internacionales.
                                        </p>
                                    </div>
                                </div>
                            </div>

                            {/* Image Section (Moved Second) */}
                            <div className="mt-8 lg:mt-0 relative h-[400px] w-full bg-slate-900 rounded-3xl overflow-hidden shadow-2xl flex items-center justify-center group transform transition-all duration-500 hover:scale-[1.02]">
                                <img
                                    src={imgMantencion}
                                    alt="Mantención Especializada"
                                    className="w-full h-full object-cover transition-transform duration-[2000ms] group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                                {/* Optional: Decorative overlay or label if needed, keeping it clean for now */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </LandingLayout>
    );
};

export default LandingServicios;
